export function getHotelFacilityIcon(facilityName: string): string {
	return {
		'Lage & Strand': 'beach',
		'Sport & Aktivitäten': 'entertainment',
		'Restaurant & Essen': 'catering',
		Wohlbefinden: 'wellness',
		'Familie & Kinder': 'family',
		'Ausstattung & Services': 'equipment',
		Hoteltyp: 'hotel',

	}[facilityName] || 'hotel';
}
